import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
	createDateTimeSlice,
	type DateTimeSlice,
} from './slices/dateTimeSlice';
import { createUISlice, type UISlice } from './slices/uiSlice';
import { createConfigSlice, type ConfigSlice } from './slices/configSlice';
import {
	createServicesSlice,
	type ServicesSlice,
} from './slices/servicesSlice';
import {
	createResourcesSlice,
	type ResourcesSlice,
} from './slices/resourcesSlice';
import {
	createFormFieldsSlice,
	type FormFieldsSlice,
} from './slices/formFieldsSlice';

type BookingStore = DateTimeSlice &
	UISlice &
	ConfigSlice &
	ServicesSlice &
	ResourcesSlice &
	FormFieldsSlice;

export const useBookingStore = create<BookingStore>()(
	devtools(
		(...a) => ({
			...createDateTimeSlice(...a),
			...createUISlice(...a),
			...createConfigSlice(...a),
			...createServicesSlice(...a),
			...createResourcesSlice(...a),
			...createFormFieldsSlice(...a),
		}),
		{ name: 'BookingStore' }
	)
);
